import React,{useEffect,useState}  from 'react'
import axios from 'axios'
function Banner() {

  const [movies,setMovies]=useState([]);
  const apikey1=
  useEffect(()=>{
    axios.get(`https://api.themoviedb.org/3/trending/movie/week?api_key=5540e483a20e0b20354dabc2d66a31c9&page=1`).then((res)=>{
      setMovies(res.data.results[0])
    })
  },[])
  return (
    <>
        <div className={`bg-[url(https://image.tmdb.org/t/p/original//${movies?.backdrop_path})] bg-cover h-[40vh] md:h-[60vh] bg-center flex items-end`}>
            <div className=" text-xl md:text-3xl p-6 text-white font-bold flex justify-center bg-gray-900 bg-opacity-50 w-full rounded-3xl">
                {movies?.title}
            </div>
        </div>
    </>
  )
}

export default Banner
